import { Button } from '@resurs/midas-react'
import withAuthority from '../../higher-order/with-authority'

const AuthorizedButton = withAuthority()(Button)

AuthorizedButton.propTypes = {
  ...Button.propTypes,
  ...AuthorizedButton.propTypes,
}

export default AuthorizedButton
